import { AnnouncementsTotalPerCustomerListItemGroupModel } from './announcements-total-per-customer-list-item-group-model';
import { AnnouncementsTotalPerCustomerListItemHeadModel } from './announcements-total-per-customer-list-item-head-model';

import { Serializable } from '../../../core/models/serializable';

export class AnnouncementsTotalPerCustomerListItemModel
  implements Serializable<AnnouncementsTotalPerCustomerListItemModel>
{
  fromObject(obj: any): AnnouncementsTotalPerCustomerListItemModel {
    Object.assign(this, obj);
    this.head = null;
    this.groups = [];

    if (obj.head != null) {
      let t = new AnnouncementsTotalPerCustomerListItemHeadModel();
      t = t.fromObject(obj.head);
      this.head = t;
    }

    if (obj.groups && obj.groups.length && obj.groups.length > 0) {
      obj.groups.forEach((a) => {
        let t = new AnnouncementsTotalPerCustomerListItemGroupModel();
        t = t.fromObject(a);
        this.groups.push(t);
      });
    }

    return this;
  }

  toObject() {
    throw new Error('Method not implemented.');
  }

  public head: AnnouncementsTotalPerCustomerListItemHeadModel;
  public groups: AnnouncementsTotalPerCustomerListItemGroupModel[];
}
